import { render } from "./view-configuration.vue?vue&type=template&id=5f5e998a"
import script from "./view-configuration.vue?vue&type=script&lang=js"
export * from "./view-configuration.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__